import React from 'react';
import {FormattedHTMLMessage, FormattedMessage, injectIntl} from 'react-intl';
import {createFragmentContainer, graphql} from 'react-relay';
import {withRouter} from 'react-router-dom';
import UpdateCompanyMutation from '../../../mutations/update_company_mutation.modern';
import VerifyTimeLogIntegrationMutation from '../../../mutations/verify_timelog_integration_mutation';
import * as tracking from '../../../tracking';
import timeLogLogo from '../../../images/integrations/timelog-logo.png';
import CustomScrollDiv from '../../../forecast-app/shared/components/scroll-bars/custom_scroll_div';
import TimeLogErrorView from './app_timelog_error_view';
import TimeLogMovedTasks from './app_timelog_moved_tasks_view';
import TimeLogInstallResultView from './app_timelog_install_result_view';
import Util from '../../../forecast-app/shared/util/util';
import {MODAL_TYPE, showModal} from '../../../forecast-app/shared/components/modals/generic_modal_conductor';
import {BUTTON_STYLE, BUTTON_COLOR, ELEMENT_TYPE} from '../../../constants';
import {usingTimeApproval} from '../../../forecast-app/shared/util/FeatureUtil';
import {TimeApprovalIncompatibleContent} from './TimeApprovalIncompatibleContent';
import {buildThirdLevelNavHeader} from '../../../forecast-app/shared/components/headers/header-bar/header_bar';

class appTimelog extends React.Component {
	constructor(props) {
		super(props);

		const company = props.viewer.company;

		this.state = {
			timelogAccountDomain: company.timelogAccountDomain ? company.timelogAccountDomain : '',
			timelogAccountName: company.timelogAccountName ? company.timelogAccountName : '',
			timelogAccountUserName: company.timelogAccountUserName ? company.timelogAccountUserName : '',
			timelogAccountPassword: company.timelogAccountPassword ? company.timelogAccountPassword : '',
			timelogAccountSiteCode: company.timelogAccountSiteCode ? company.timelogAccountSiteCode : '',
			timelogAccountReportingUserName: company.timelogAccountReportingUserName ? company.timelogAccountReportingUserName : '',
			timelogAccountReportingPassword: company.timelogAccountReportingPassword ? company.timelogAccountReportingPassword : '',
			showTimeLogErrorsModal: false,
			showMovedTasks: false,
			verifying: false,
			verifyingSave: false,
			showInstallResult: false,
			timeLogInitialUserMappingResponse: [],
		};
	}

	componentDidMount() {
		document.title = 'TimeLog - Apps & Integrations - Forecast';
		// Segment
		tracking.trackPage('settings-app-catalog-timelog');
	}

	handleChange(property, e) {
		this.setState({[property]: e.target.value});
	}

	enableDisable() {
		const {formatMessage} = this.props.intl;
		if (this.props.viewer.company.timelogEnabled) {
			const deactivateForReal = () => {
				Util.CommitMutation(UpdateCompanyMutation, {
					id: this.props.viewer.company.id,
					timelogDeactivate: true,
				});
				this.setState({
					timelogAccountDomain: '',
					timelogAccountName: '',
					timelogAccountUserName: '',
					timelogAccountPassword: '',
					timelogAccountSiteCode: '',
					timelogAccountReportingUserName: '',
					timelogAccountReportingPassword: '',
				});
			};

			showModal({
				type: MODAL_TYPE.WARNING,
				warningMessageId: 'warning-modal.edit-warning-title',
				warningInformation: [formatMessage({id: 'settings.app_catalog.timelog.deactivate_warning'})],
				buttons: [
					{
						text: formatMessage({id: 'common.cancel'}),
						style: BUTTON_STYLE.FILLED,
						color: BUTTON_COLOR.WHITE,
					},
					{
						text: formatMessage({id: 'common.deactivate'}),
						style: BUTTON_STYLE.FILLED,
						color: BUTTON_COLOR.RED,
						callback: deactivateForReal,
					},
				],
			});
			this.setState({verifying: false});
		} else {
			if (this.state.timelogAccountDomain === '') {
				this._account_domain.focus();
				return;
			}
			if (this.state.timelogAccountName === '') {
				this._account_name.focus();
				return;
			}
			if (this.state.timelogAccountUserName === '') {
				this._account_user_name.focus();
				return;
			}
			if (this.state.timelogAccountPassword === '') {
				this._account_account_password.focus();
				return;
			}
			if (this.state.timelogAccountSiteCode === '') {
				this._account_site_code.focus();
				return;
			}
			if (this.state.timelogAccountReportingUserName === '') {
				this._account_reporting_username.focus();
				return;
			}
			if (this.state.timelogAccountReportingPassword === '') {
				this._account_reporting_password.focus();
				return;
			}

			this.setState({verifying: true});
			const onSuccess = response => {
				this.setState({
					verifying: false,
					showInstallResult: true,
					timeLogInitialUserMappingResponse: response.verifyTimeLogIntegration.timeLogInitialUserMappingResponse,
				});
				if (response.verifyTimeLogIntegration.success) {
					tracking.trackEvent('Timelog integration enabled');
				} else {
					showModal({
						type: MODAL_TYPE.WARNING,
						warningMessageId: 'integration.verification_failed',
						warningInformation: [response.verifyTimeLogIntegration.message],
						buttons: [
							{
								text: formatMessage({id: 'common.ok'}),
								style: BUTTON_STYLE.FILLED,
								color: BUTTON_COLOR.WHITE,
							},
						],
					});
				}
			};

			Util.CommitMutation(
				VerifyTimeLogIntegrationMutation,
				{
					timelogAccountDomain: this.state.timelogAccountDomain,
					timelogAccountName: this.state.timelogAccountName,
					timelogAccountUserName: this.state.timelogAccountUserName,
					timelogAccountPassword: this.state.timelogAccountPassword,
					timelogAccountSiteCode: this.state.timelogAccountSiteCode,
					timelogAccountReportingUserName: this.state.timelogAccountReportingUserName,
					timelogAccountReportingPassword: this.state.timelogAccountReportingPassword,
					update: false,
				},
				onSuccess
			);
		}
	}

	showTimeLogErrors() {
		this.setState({showTimeLogErrorsModal: true});
	}

	dontShowTimeLogErrors() {
		this.setState({showTimeLogErrorsModal: false});
	}

	closeInitialModal() {
		this.setState({showInstallResult: false});
	}

	toggleMovedTasks(value) {
		this.setState({showMovedTasks: value});
	}

	verifyAndSave() {
		const {formatMessage} = this.props.intl;
		this.setState({verifyingSave: true});
		const onSuccess = response => {
			this.setState({verifyingSave: false});
			if (response.verifyTimeLogIntegration.success) {
				showModal({
					type: MODAL_TYPE.WARNING,
					warningMessageId: 'integration.verification_success',
					warningInformation: [formatMessage({id: 'integration.verification_succeeded'})],
					useInfoIcon: true,
					buttons: [
						{
							text: formatMessage({id: 'common.ok'}),
							style: BUTTON_STYLE.FILLED,
							color: BUTTON_COLOR.WHITE,
						},
					],
				});
			} else {
				showModal({
					type: MODAL_TYPE.WARNING,
					warningMessageId: 'integration.verification_failed',
					warningInformation: [response.verifyTimeLogIntegration.message],
					buttons: [
						{
							text: formatMessage({id: 'common.ok'}),
							style: BUTTON_STYLE.FILLED,
							color: BUTTON_COLOR.WHITE,
						},
					],
				});
			}
		};

		Util.CommitMutation(
			VerifyTimeLogIntegrationMutation,
			{
				timelogAccountDomain: this.state.timelogAccountDomain,
				timelogAccountName: this.state.timelogAccountName,
				timelogAccountUserName: this.state.timelogAccountUserName,
				timelogAccountPassword: this.state.timelogAccountPassword,
				timelogAccountSiteCode: this.state.timelogAccountSiteCode,
				timelogAccountReportingUserName: this.state.timelogAccountReportingUserName,
				timelogAccountReportingPassword: this.state.timelogAccountReportingPassword,
				update: true,
			},
			onSuccess
		);
	}

	openHelpCenter() {
		window.open('http://help.forecast.it/integrations/time-tracking/timelog');
	}

	getHeader() {
		const leftContent = [],
			rightContent = [];

		leftContent.push({type: ELEMENT_TYPE.BACK_BUTTON, onClick: this.props.history.goBack});

		return buildThirdLevelNavHeader(leftContent, rightContent);
	}

	render() {
		const {formatMessage} = this.props.intl;

		const useTimeApproval = usingTimeApproval(this.props.viewer.company);

		let enableButtonText = formatMessage({id: 'settings.app_catalog.timelog.activate_button'});
		if (this.state.verifying) {
			enableButtonText = formatMessage({id: 'settings.app_catalog.verifying_button'});
		} else if (this.props.viewer.company.timelogEnabled) {
			enableButtonText = formatMessage({id: 'settings.app_catalog.timelog.deactivate_button'});
		}
		return (
			<div className="section-content settings-app settings-app-page">
				{this.state.showTimeLogErrorsModal ? <TimeLogErrorView errors={this.props.viewer.company.timelogFailedTimeRegs} close={this.dontShowTimeLogErrors.bind(this)} viewer={this.props.viewer} /> : null}
				{this.state.showMovedTasks ? <TimeLogMovedTasks movedTasks={this.props.viewer.company.timelogMovedTasks} close={this.toggleMovedTasks.bind(this, false)} viewer={this.props.viewer} /> : null}
				{this.state.showInstallResult ? <TimeLogInstallResultView timeLogInitialUserMappingResponse={this.state.timeLogInitialUserMappingResponse} close={this.closeInitialModal.bind(this)} viewer={this.props.viewer} /> : null}
				{this.props.children}
				{this.getHeader()}
				<CustomScrollDiv>
					<div className="section-body">
						<div className="inner">
							<fieldset className="general">
								<div className="header-wrapper">
									<img width={100} height={100} alt="timelog logo" src={timeLogLogo} />
									<div className="title-description-wrapper">
										<div className="description">
											<FormattedHTMLMessage id="settings.app_catalog.timelog.description" />
										</div>
									</div>
								</div>
								{useTimeApproval ? (
									<TimeApprovalIncompatibleContent integrationName={'Timelog'} />
								) : (
									<>
										<div className="input-fields">
											<label htmlFor="timelog_account_domain">
												<FormattedMessage id="settings.app_catalog.timelog.account_domain" />
												<input
													id="timelog_account_domain"
													type="text"
													ref={input => (this._account_domain = input)}
													placeholder={formatMessage({id: 'settings.app_catalog.timelog.account_domain_placeholder'})}
													value={this.state.timelogAccountDomain}
													onChange={this.handleChange.bind(this, 'timelogAccountDomain')}
												/>
											</label>
											<label htmlFor="timelog_account_name">
												<FormattedMessage id="settings.app_catalog.timelog.account_name" />
												<input
													id="timelog_account_name"
													type="text"
													ref={input => (this._account_name = input)}
													placeholder={formatMessage({id: 'settings.app_catalog.timelog.account_name_placeholder'})}
													value={this.state.timelogAccountName}
													onChange={this.handleChange.bind(this, 'timelogAccountName')}
												/>
											</label>
											<label htmlFor="timelog_account_user_name">
												<FormattedMessage id="settings.app_catalog.timelog.account_user_name" />
												<input
													id="timelog_account_user_name"
													type="text"
													ref={input => (this._account_user_name = input)}
													placeholder={formatMessage({id: 'settings.app_catalog.timelog.account_user_name_placeholder'})}
													value={this.state.timelogAccountUserName}
													onChange={this.handleChange.bind(this, 'timelogAccountUserName')}
												/>
											</label>
											<label htmlFor="timelog_account_account_password">
												<FormattedMessage id="settings.app_catalog.timelog.account_account_password" />
												<input
													id="timelog_account_account_password"
													type="password"
													ref={input => (this._account_account_password = input)}
													placeholder={formatMessage({id: 'settings.app_catalog.timelog.account_account_password_placeholder'})}
													value={this.state.timelogAccountPassword}
													onChange={this.handleChange.bind(this, 'timelogAccountPassword')}
													autoComplete="new-password"
												/>
											</label>
											<label htmlFor="timelog_account_site_code">
												<FormattedMessage id="settings.app_catalog.timelog.account_site_code" />
												<input
													id="timelog_account_site_code"
													type="text"
													ref={input => (this._account_site_code = input)}
													placeholder={formatMessage({id: 'settings.app_catalog.timelog.account_site_code_placeholder'})}
													value={this.state.timelogAccountSiteCode}
													onChange={this.handleChange.bind(this, 'timelogAccountSiteCode')}
												/>
											</label>
											<label htmlFor="timelog_account_reporting_username">
												<FormattedMessage id="settings.app_catalog.timelog.account_reporting_username" />
												<input
													id="timelog_account_reporting_username"
													type="text"
													ref={input => (this._account_reporting_username = input)}
													placeholder={formatMessage({id: 'settings.app_catalog.timelog.account_reporting_username_placeholder'})}
													value={this.state.timelogAccountReportingUserName}
													onChange={this.handleChange.bind(this, 'timelogAccountReportingUserName')}
												/>
											</label>
											<label htmlFor="timelog_account_reporting_password">
												<FormattedMessage id="settings.app_catalog.timelog.account_reporting_password" />
												<input
													id="timelog_account_reporting_password"
													type="password"
													ref={input => (this._account_reporting_password = input)}
													placeholder={formatMessage({id: 'settings.app_catalog.timelog.account_reporting_password_placeholder'})}
													value={this.state.timelogAccountReportingPassword}
													onChange={this.handleChange.bind(this, 'timelogAccountReportingPassword')}
													autoComplete="new-password"
												/>
											</label>
											{this.props.viewer.company.timelogEnabled ? (
												<button disabled={this.state.verifyingSave} className="submit-button save-button" onClick={this.verifyAndSave.bind(this)}>
													{this.state.verifyingSave ? formatMessage({id: 'settings.app_catalog.verifying_button'}) : formatMessage({id: 'common.save'})}
												</button>
											) : null}
											<button disabled={this.state.verifying} className="submit-button" onClick={this.enableDisable.bind(this)}>
												{enableButtonText}
											</button>
											<button className="help-button" onClick={this.openHelpCenter.bind(this)}>
												<FormattedMessage id="settings.app_catalog.help_button" />
											</button>
										</div>

										<div>
											<button className="settings-app-timelog timelog-error-button" onClick={this.showTimeLogErrors.bind(this)} disabled={this.props.viewer.company.timelogFailedTimeRegs.edges.length === 0}>
												{this.props.viewer.company.timelogFailedTimeRegs.edges.length} {formatMessage({id: 'settings.app_catalog.timelog.integration_error'})}
											</button>
										</div>
										<div>
											<button className="settings-app-timelog timelog-error-button" onClick={this.toggleMovedTasks.bind(this, true)} disabled={this.props.viewer.company.timelogMovedTasks.edges.length === 0}>
												{this.props.viewer.company.timelogMovedTasks.edges.length} {formatMessage({id: 'settings.app_catalog.timelog.task_error'})}
											</button>
										</div>
									</>
								)}
								{this.props.viewer.company.timelogEnabled ? (
									<div className="timelog-latest-runtime">
										<b>{formatMessage({id: 'settings.app_catalog.timelog.lastest_runtime'})}: </b>
										{this.props.viewer.company.timelogLatestRuntime ? this.props.viewer.company.timelogLatestRuntime : 'N/A'}{' '}
									</div>
								) : null}
							</fieldset>
						</div>
					</div>
				</CustomScrollDiv>
			</div>
		);
	}
}

const appTimelogQuery = graphql`
	query appTimelog_Query {
		viewer {
			actualPersonId
			component(name: "app_timelog")
			...appTimelog_viewer
		}
	}
`;

export {appTimelogQuery};

export default createFragmentContainer(injectIntl(withRouter(appTimelog)), {
	viewer: graphql`
		fragment appTimelog_viewer on Viewer {
			id
			availableFeatureFlags {
				key
			}
			company {
				id
				useTimeApproval
				modules {
					moduleType
				}
				timelogEnabled
				timelogAccountDomain
				timelogAccountName
				timelogAccountUserName
				timelogAccountPassword
				timelogAccountSiteCode
				timelogAccountReportingUserName
				timelogAccountReportingPassword
				timelogLatestRuntime
				timelogFailedTimeRegs(first: 10000) {
					edges {
						node {
							id
							year
							month
							day
							minutesRegistered
							notes
							timeLogErrorText
							timeLogMarkedForRetry
							person {
								id
								firstName
								lastName
							}
							task {
								id
								name
								project {
									name
								}
							}
							project {
								id
								name
							}
						}
					}
				}
				timelogMovedTasks(first: 10000) @connection(key: "Company_timelogMovedTasks") {
					edges {
						node {
							id
							companyTaskId
							name
						}
					}
				}
			}
		}
	`,
});
